import { DateTime, Duration } from 'luxon';

/** Remove time zone from ISO string */
export function stripTimeZone(isoString: string): string {
  if (isoString && isoString.length > 19) {
    return isoString.substring(0, 19);
  }
  return isoString;
}

/** Remove time portion (TXX:XX:XX) of ISO datetime string. Useful when comparing date only. */
export function stripTime(isoString: string): string {
  if (isoString && isoString.length > 10) {
    return isoString.slice(0, 10);
  }
  return isoString;
}

/** Sequence number needs to be 5 digits. Add leading zeroes if necessary. */
export function sequenceNumPadZeroes(seqNumber: number): string {
  return seqNumber.toString().padStart(5, '0');
}

/** Create deep copy of object. */
export function deepCopy(object: object): object {
  return JSON.parse(JSON.stringify(object));
}

/** Convert string of format 00:00:00 or 0.00:00:00 (day value) to Luxon Duration. Ignores seconds. Return duration of 0 on failure. */
export function timeStringToDuration(timeString: string): Duration {
  const withDayRe = /(\d{1,2}).(\d{2}):(\d{2}):\d{2}/;
  const withDayMatch = timeString.match(withDayRe);

  const withoutDayRe = /^(\d{2}):(\d{2}):\d{2}/;
  const withoutDayMatch = timeString.match(withoutDayRe);

  if (withDayMatch) {
    const days = parseInt(withDayMatch[1]);
    const hours = parseInt(withDayMatch[2]);
    const minutes = parseInt(withDayMatch[3]);
    return Duration.fromObject({ days, hours, minutes });
  } else if (withoutDayMatch) {
    const hours = parseInt(withoutDayMatch[1]);
    const minutes = parseInt(withoutDayMatch[2]);
    return Duration.fromObject({ hours, minutes });
  } else {
    return Duration.fromObject({ minutes: 0 });
  }
}

/** Convert 'pay time minutes' string (PT60M) to Luxon Duration. Returns duration of 0 on failure. */
export function payTimeToDuration(payTimeString: string): Duration {
  const re = /PT(\d+)M/;
  const match = payTimeString.match(re);

  if (match) {
    const minutes = parseInt(match[1]);
    return Duration.fromObject({ minutes });
  }

  return Duration.fromObject({ minutes: 0 });
}

/** Returns the start date of the bid month given or null if invalid. Takes a numeric month (1-12) and year.
 *  Needed because some bid months don't start on the first. */
export function getBidMonthStartDate(
  month: number,
  year: number
): DateTime | null {
  switch (month) {
    case 1:
      return DateTime.fromObject({ year, month: 1, day: 1 });
    case 2:
      return DateTime.fromObject({ year, month: 1, day: 31 });
    case 3:
      return DateTime.fromObject({ year, month: 3, day: 2 });
    case 4:
      return DateTime.fromObject({ year, month: 4, day: 1 });
    case 5:
      return DateTime.fromObject({ year, month: 5, day: 2 });
    case 6:
      return DateTime.fromObject({ year, month: 6, day: 2 });
    case 7:
      return DateTime.fromObject({ year, month: 7, day: 2 });
    case 8:
      return DateTime.fromObject({ year, month: 8, day: 1 });
    case 9:
      return DateTime.fromObject({ year, month: 8, day: 31 });
    case 10:
      return DateTime.fromObject({ year, month: 10, day: 1 });
    case 11:
      return DateTime.fromObject({ year, month: 11, day: 1 });
    case 12:
      return DateTime.fromObject({ year, month: 12, day: 2 });
    default:
      return null;
  }
}

export function designateTagType(dh: boolean | undefined, cx: boolean | undefined): string {
  if (dh && cx) {
    return "CX"
  }
  else if(dh) {
    return "DH";
  }
  else if (cx) {
    return "CX";
  }
  else {
    return "FLT"
  }
}

export function formatTime(minutes: number): string {
    const hours = Math.floor(minutes / 60).toLocaleString();
    const minutesLeft = minutes % 60;
    return `${hours}:${minutesLeft < 10 ? '0': ''}${minutesLeft}`
}




